/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppTeamsRendererQueryVariables = {};
export type WebAppTeamsRendererQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"WebAppTeamsRenderer_viewer">;
    };
};
export type WebAppTeamsRendererQuery = {
    readonly response: WebAppTeamsRendererQueryResponse;
    readonly variables: WebAppTeamsRendererQueryVariables;
};



/*
query WebAppTeamsRendererQuery {
  viewer {
    ...WebAppTeamsRenderer_viewer
    id
  }
}

fragment WebAppNavAvatarMenu_viewer on Viewer {
  id
  user {
    givenName
    familyName
    externalImageUrl
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          previousState
          current {
            id
            state
            percentComplete
            errorMessage
          }
          pending {
            id
            state
            percentComplete
            errorMessage
          }
        }
      }
    }
    dataSources(first: 1000000) {
      edges {
        node {
          id
          status
          name
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          id
          primaryOrgCalendar
          domains
          slackAccountsErrorable {
            __typename
            ... on SlackAccountList {
              list {
                id
                slackTeamId
                slackUserId
                teamDisplayName
              }
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          eventColoringSettingsErrorable {
            __typename
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on EventColoringSettings {
              eventCategoryColorings {
                googleColorKey
                eventCategory
                active
                isUserSet
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          userPerson {
            __typename
            ... on Person {
              profile {
                givenName
                familyName
                externalImageUrl
              }
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
        }
      }
    }
    id
  }
}

fragment WebAppTeamsRenderer_viewer on Viewer {
  ...WebAppNavAvatarMenu_viewer
  id
  user {
    flowStates(first: 1000000) {
      edges {
        node {
          id
          flowKey
          previousState
          current {
            id
            state
            percentComplete
            errorMessage
          }
          pending {
            id
            state
            percentComplete
            errorMessage
          }
        }
      }
    }
    orgs(first: 1000000) {
      edges {
        node {
          experiments
          id
          primaryOrgCalendar
        }
      }
    }
    webAppFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    chromeExtensionFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
    id
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalImageUrl",
        "storageKey": null
    } as any, v4 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v5 = [
        (v0 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v9 = {
        "kind": "InlineFragment",
        "selections": [
            (v8 /*: any*/),
            (v7 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v10 = {
        "kind": "InlineFragment",
        "selections": [
            (v0 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v11 = [
        (v6 /*: any*/),
        (v9 /*: any*/),
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flags",
                    "storageKey": null
                }
            ],
            "type": "Flags",
            "abstractKey": null
        } as any,
        (v10 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebAppTeamsRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WebAppTeamsRenderer_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WebAppTeamsRendererQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": "FlowStateConnection",
                                    "kind": "LinkedField",
                                    "name": "flowStates",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FlowStateEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "FlowState",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "flowKey",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "previousState",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "current",
                                                            "plural": false,
                                                            "selections": (v5 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "FlowStatus",
                                                            "kind": "LinkedField",
                                                            "name": "pending",
                                                            "plural": false,
                                                            "selections": (v5 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "flowStates(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "status",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "slackAccountsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SlackAccount",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v0 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "slackTeamId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "slackUserId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamDisplayName",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SlackAccountList",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "eventColoringSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                (v9 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "EventCategoryColoring",
                                                                            "kind": "LinkedField",
                                                                            "name": "eventCategoryColorings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "googleColorKey",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventCategory",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "active",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isUserSet",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventColoringSettings",
                                                                    "abstractKey": null
                                                                },
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userPerson",
                                                            "plural": false,
                                                            "selections": [
                                                                (v6 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "UserProfile",
                                                                            "kind": "LinkedField",
                                                                            "name": "profile",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Person",
                                                                    "abstractKey": null
                                                                },
                                                                (v10 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": (v11 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "chromeExtensionFlagsErrorable",
                                    "plural": false,
                                    "selections": (v11 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "dcafe02ba0f8f6407a2652992a859513",
            "id": null,
            "metadata": {},
            "name": "WebAppTeamsRendererQuery",
            "operationKind": "query",
            "text": "query WebAppTeamsRendererQuery {\n  viewer {\n    ...WebAppTeamsRenderer_viewer\n    id\n  }\n}\n\nfragment WebAppNavAvatarMenu_viewer on Viewer {\n  id\n  user {\n    givenName\n    familyName\n    externalImageUrl\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n      }\n    }\n    dataSources(first: 1000000) {\n      edges {\n        node {\n          id\n          status\n          name\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          id\n          primaryOrgCalendar\n          domains\n          slackAccountsErrorable {\n            __typename\n            ... on SlackAccountList {\n              list {\n                id\n                slackTeamId\n                slackUserId\n                teamDisplayName\n              }\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          eventColoringSettingsErrorable {\n            __typename\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on EventColoringSettings {\n              eventCategoryColorings {\n                googleColorKey\n                eventCategory\n                active\n                isUserSet\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userPerson {\n            __typename\n            ... on Person {\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment WebAppTeamsRenderer_viewer on Viewer {\n  ...WebAppNavAvatarMenu_viewer\n  id\n  user {\n    flowStates(first: 1000000) {\n      edges {\n        node {\n          id\n          flowKey\n          previousState\n          current {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n          pending {\n            id\n            state\n            percentComplete\n            errorMessage\n          }\n        }\n      }\n    }\n    orgs(first: 1000000) {\n      edges {\n        node {\n          experiments\n          id\n          primaryOrgCalendar\n        }\n      }\n    }\n    webAppFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    chromeExtensionFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    id\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6fc074a8d40ac6258dbd1880050661de';
export default node;
